<ion-header>
  <ion-toolbar>
    @if (!keg?.id) {
      <ion-title>Add Keg</ion-title>
    }
    @if (keg?.id) {
      <ion-title>{{ keg?.name }}</ion-title>
    }
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- <ion-item *ngIf="keg" lines="none">
  <ion-thumbnail slot="start">
    <img src="/assets/icons/flat/beer/keg.svg" />
  </ion-thumbnail>
  {{ keg.name }}
  <ion-buttons slot="end">
    <ion-button (click)="keg = null">
      <ion-icon
        slot="icon-only"
        color="danger"
        name="trash-outline"
      ></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-item> -->
@if (!keg) {
  <ng-content>
    <ion-grid style="height: 100%; display: flex; flex-flow: column">
      <ion-row>
        @for (keg of kegs; track keg; let i = $index) {
          <ion-col
            size-xs="12"
            size-md="6"
            >
            <ion-card button="true" (click)="selectKeg(keg)" class="ion-no-margin ps-h-100">
              <ion-card-content>
                <ion-item lines="none">
                  <ion-thumbnail slot="start">
                    @if (keg.container === 'PubKeg' || !keg.container) {
                      <app-keg-svg
                        [item]="keg"
                      ></app-keg-svg>
                    }
                    @if (keg.container === 'CornyKeg') {
                      <app-cornykeg-svg
                        [item]="keg"
                      ></app-cornykeg-svg>
                    }
                    @if (keg.container === 'CornyKeg12') {
                      <app-cornykeg12-svg
                        [item]="keg"
                      ></app-cornykeg12-svg>
                    }
                    @if (keg.container === 'CornyKeg09') {
                      <app-cornykeg09-svg
                        [item]="keg"
                      ></app-cornykeg09-svg>
                    }
                  </ion-thumbnail>
                  <ion-text>
                    <h2>{{ keg.name }}</h2>
                    <ul class="ion-item-list list-inline-note">
                      @if (keg.tap?.id) {
                        <li>
                          <ion-icon src="assets/icons/flat/beer/tap.svg"></ion-icon>
                          <span>{{ keg.tap?.name }}</span>
                        </li>
                      }
                      @if (keg.beverage?.name) {
                        <li>
                          <ion-icon
                            src="assets/icons/flat/beer/glass-mug-2.svg"
                          ></ion-icon>
                          <span>{{ keg.beverage?.name }}</span>
                        </li>
                      }
                      @if (keg.tap?.plaato?.name) {
                        <li>
                          <ion-icon
                            src="assets/images/companies/plaato-logo3.svg"
                          ></ion-icon>
                          <span> {{ keg.tap?.plaato?.name }}</span>
                        </li>
                      }
                      @if (keg.tap?.kegtron?.name) {
                        <li>
                          <ion-icon
                            src="assets/images/companies/kegtron-logo.svg"
                          ></ion-icon>
                          <span> {{ keg.tap?.kegtron?.name }}</span>
                        </li>
                      }
                      @if (keg.tap?.customKegMon?.name) {
                        <li>
                          <ion-icon
                            src="assets/images/companies/custom-keg-monitor.svg"
                          ></ion-icon>
                          <span> {{ keg.tap?.customKegMon?.name }}</span>
                        </li>
                      }
                    </ul>
                  </ion-text>
                </ion-item>
              </ion-card-content>
            </ion-card>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
  </ng-content>
}

@if (keg) {
  <ng-content>
    <form [formGroup]="form" class="ion-padding">
      <ion-text color="medium">
        <h6 style="margin-top:0;">Location</h6>
      </ion-text>
      <ion-card class="ion-no-margin ion-no-padding">
        <ion-card-content class="ion-no-padding">
          <ion-item lines="none">
            <ion-select
              label="Location"
              labelPlacement="floating"
              formControlName="location"
              interface="popover"
              (ionChange)="updateLocation($event)"
              >
              <ion-select-option value="">Choose location</ion-select-option>
              @for (location of locations; track location) {
                <ion-select-option
                  [value]="location.id"
                  >
                  {{ location.name }}
                </ion-select-option>
              }
            </ion-select>
          </ion-item>
        </ion-card-content>
      </ion-card>
      <div>
        <ion-text color="medium">
          <h6>Dates</h6>
        </ion-text>
        <ion-card class="ion-no-margin ion-no-padding">
          <ion-card-content class="ion-no-padding">
            <ion-item lines="full">
              <ion-label>Kegging Date</ion-label>
              @if (tapDate) {
                <ion-datetime-button
                  slot="end"
                  datetime="tapDate"
                ></ion-datetime-button>
              }
              @if (!keg.tapDate) {
                <ion-button (click)="setDefaultKegTapDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                  <ion-icon
                    size="small"
                    slot="icon-only"
                    name="add-circle-outline"
                  ></ion-icon>
                </ion-button>
              }
              @if (keg.tapDate) {
                <ion-button (click)="deleteKegTapDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                  <ion-icon
                    size="small"
                    slot="icon-only"
                    name="trash-outline"
                  ></ion-icon>
                </ion-button>
              }
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  @if (tapDate) {
                    <ion-datetime
                      presentation="date"
                      [value]="tapDate"
                      size="cover"
                      id="tapDate"
                      (ionChange)="setKegTapDate($event)"
                      showDefaultButtons="true"
                      >
                      <span slot="title">Keg Date</span>
                    </ion-datetime>
                  }
                </ng-template>
              </ion-modal>
            </ion-item>
            <ion-item lines="none">
              <ion-label>Best Before Date</ion-label>
              @if (bestBeforeDate) {
                <ion-datetime-button
                  slot="end"
                  datetime="bestBeforeDate"
                ></ion-datetime-button>
              }
              @if (!keg.bestBeforeDate) {
                <ion-button (click)="setDefaultKegBestBeforeDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                  <ion-icon
                    size="small"
                    slot="icon-only"
                    name="add-circle-outline"
                  ></ion-icon>
                </ion-button>
              }
              @if (keg.bestBeforeDate) {
                <ion-button (click)="deleteKegBestBeforeDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                  <ion-icon
                    size="small"
                    slot="icon-only"
                    name="trash-outline"
                  ></ion-icon>
                </ion-button>
              }
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  @if (bestBeforeDate) {
                    <ion-datetime
                      max="2100-12-31"
                      presentation="date"
                      [value]="bestBeforeDate"
                      size="cover"
                      id="bestBeforeDate"
                      (ionChange)="setKegBestBeforeDate($event)"
                      showDefaultButtons="true"
                      >
                      <span slot="title">Best Before Date</span>
                    </ion-datetime>
                  }
                </ng-template>
              </ion-modal>
            </ion-item>
          </ion-card-content>
        </ion-card>
      </div>
      <div>
        <ion-text color="medium">
          <h6>Notification</h6>
        </ion-text>
        <ion-card class="ion-no-margin ion-no-padding">
          <ion-card-content class="ion-no-padding">
            <ion-item lines="full">
              <ion-label>Date</ion-label>
              @if (notificationDate) {
                <ion-datetime-button
                  slot="end"
                  datetime="notificationDate"
                ></ion-datetime-button>
              }
              @if (!keg.notificationDate) {
                <ion-button slot="end" (click)="setDefaultKegNotificationDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                  <ion-icon
                    size="small"
                    slot="icon-only"
                    name="add-circle-outline"
                  ></ion-icon>
                </ion-button>
              }
              @if (keg.notificationDate) {
                <ion-button (click)="deleteKegNotificationDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                  <ion-icon
                    size="small"
                    slot="icon-only"
                    name="trash-outline"
                  ></ion-icon>
                </ion-button>
              }
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  @if (notificationDate) {
                    <ion-datetime
                      max="2100-12-31"
                      presentation="date"
                      [value]="notificationDate"
                      size="cover"
                      id="notificationDate"
                      (ionChange)="setKegNotificationDate($event)"
                      showDefaultButtons="true"
                      >
                      <span slot="title">Notification Date</span>
                    </ion-datetime>
                  }
                </ng-template>
              </ion-modal>
            </ion-item>
            <ion-item lines="none">
              <ion-input
                label="Message"
                labelPlacement="floating"
                type="text"
                formControlName="notificationMessage"
                placeholder="Message text"
                (ionBlur)="updateNotification()"
              ></ion-input>
            </ion-item>
          </ion-card-content>
        </ion-card>
      </div>
    </form>
  </ng-content>
}
</ion-content>
@if (keg) {
  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button color="success" fill="solid" (click)="dismiss(keg)">
          Save
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
}